import AuthReducer from "./AuthReducer";
import PledgeReducer from "./pledge-reducer";
import RedeemReducer from "./redeem-reducer";
import { combineReducers } from "@reduxjs/toolkit";

const allReducers = combineReducers({
  AuthReducer,
  PledgeReducer,
  RedeemReducer
});

export default allReducers;
